// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tapu_lele: PokeData = {
  "id": 786,
  "name": "tapu-lele",
  "height": 12,
  "weight": 186,
  "base_experience": 257,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FAIRY
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "withdraw",
    "psywave",
    "mean-look",
    "sweet-scent",
    "flatter",
    "skill-swap",
    "astonish",
    "aromatherapy",
    "tickle",
    "extrasensory",
    "psyshock",
    "draining-kiss",
    "moonblast",
    "aromatic-mist",
    "psychic-terrain",
    "natures-madness"
  ],
  "moves": [
    "psywave",
    "flatter",
    "aromatherapy",
    "moonblast",
    "psychic-terrain",
    "synchronize",
    "psychic-fangs",
    "kinesis",
    "future-sight",
    "zen-headbutt",
    "prismatic-cage",
    "psy-ball",
    "dazzling-gleam"
  ],
  "evolution_chain": {
    "id": 410,
    "item": null,
    "species": [
      {
        "name": "tapu-lele",
        "order": 786,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 107,
    "speed": 124,
    "ability_power": 169
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
